import React, {
  forwardRef,
  useEffect,
  useCallback
} from 'react';
import type {
  HTMLProps,
  ReactNode
} from 'react';
import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
// import track from 'src/utils/analytics';
// import analytics from 'src/analytics';
import { useAnalytics } from 'use-analytics';

interface PageProps extends HTMLProps<HTMLDivElement> {
  children?: ReactNode;
  title?: string;
}

const Page = forwardRef<HTMLDivElement, PageProps>(({
  children,
  title = '',
  ...rest
}, ref) => {
  const location = useLocation();
  const analytics = useAnalytics();

  useEffect(() => {
    if(title==='Tracktaco Tracking') return; // don't track tracktaco main page, since we use nested pages, and we don't want to track duplicated
    analytics.page({
      url: location.pathname,
      title
    });
  }, [analytics]);

  return (
    <div
      ref={ref as any}
      {...rest}
    >
      <Helmet>
        <title>{title}</title>
      </Helmet>
      {children}
    </div>
  );
});

Page.propTypes = {
  children: PropTypes.node.isRequired,
  title: PropTypes.string
};

export default Page;
